import axios from "axios";

export const getSoldOutProducts = async () => {
  const url = "/apps/store/api/v1.1/soldout-products";
  const { data } = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};
